import { mapToObject } from "./mapToObject";
import { objectToMap } from "./objectToMap";

export const freeTabWithSelection = (idTab: string) => {
    const openedTabsWithSelectionsMap: Map<string, string> = objectToMap(JSON.parse(localStorage.getItem('openedTabsWithSelections') || '{}'));
    openedTabsWithSelectionsMap.delete(idTab);

    try {
        localStorage.setItem('openedTabsWithSelections', JSON.stringify(mapToObject(openedTabsWithSelectionsMap)));
    }
    catch (err) {
        console.error(err)
    }
}